import { ACTION_GET_NEW_CLIENT_PENDING, ACTION_GET_NEW_CLIENT_SUCCESS, ACTION_GET_NEW_CLIENT_ERROR } from 'actions/client/action.client-get-new';

const initialState = {
    newClientPending: false,
    newClient: null,
    newClientError: null
}

export default function newClientReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_GET_NEW_CLIENT_PENDING:
            return {
                ...state,
                newClientPending: true
            }
        case ACTION_GET_NEW_CLIENT_SUCCESS:
            return {
                ...state,
                newClientPending: false,
                newClient: action.newClient
            }
        case ACTION_GET_NEW_CLIENT_ERROR:
            return {
                ...state,
                newClientPending: false,
                newClientError: action.error
            }
        default:
            return state;
    }
}

export const getNewClientPending = state => state.newClientReducer.newClientPending;
export const getNewClient = state => state.newClientReducer.newClient;
export const getNewClientError = state => state.newClientReducer.newClientError;
